import { IDashboardMetadata } from '../dashboard-metadata.service';
import { Chart } from '../../chart/base-chart.component';
import { OdDashboardFiltersComponent } from '../filters/od/od-dashboard-filters.component';
import { DateType } from '@app/shared/services/date.util';
import { countryHitRateIndicator, FULL_HEIGHT_GRID } from './shared-dashboard.config';
import { COUNTRY_HIT_RATE_COLUMNS } from './COUNTRY_HIT_RATE-dashboard.config';

export const OD_BP_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'BP KPI',
  filterComponent: {
    name: OdDashboardFiltersComponent,
    inputs: {
      showNAMFilter: true,
      showDIYFilter: false
    }
  },
  chartLink: Chart.BP,
  mapping: {
    Odlname: 'pss.id',
    Pacomnm: 'bp.companyCountryId',
    Decurce: 'currency.id',
    Devincl: 'vatIncl.id',
    Pacgrid: 'bpGroup.id',
    Denamid: 'nam.id',
    Oddesk: 'bpDesk'
  },
  fixedFilters: {
    Decurce: 'EUR',
    Devincl: '0'
  },
  reports: [
    {
      id: 175,
      key: 'CUSTOMERS_IN_COUNTRY',
      comments: 'All customers in 1 country',
      columns: COUNTRY_HIT_RATE_COLUMNS,
      gridHeight: FULL_HEIGHT_GRID,
      partialRender: true,
      fixedFilters: {
        Excludedemo: 1,
        Allowed_to_contact_local_customer: 1,
        Webshop_exclude_country_ds: 1
      },
      indicatorFn: countryHitRateIndicator
    },
    {
      id: 31,
      key: 'NEW_CUSTOMERS_THIS_MONTH',
      storedReport: 'NEW_CUSTOMERS_CREATED_BP',
      mapping: {
        Decomnm: 'bp.company.id',
        Decounm: 'bp.country.id',
        Decgrid: 'bpGroup.id',
        Deconid_search: 'nam.id'
      }
    },
    {
      id: 74,
      key: 'BP_COVERAGE_STATUS',
      fixedFilters: {
        Bp_profile_tab: '/acsl-info'
      },
      mapping: {
        Decodnm: 'pss.id',
        Deccoid: 'bp.companyCountryId'
      },
      columns: [
        'Detimes', //Timeslot
        'Decodnm', //OD
        'Decomnm', //Company name
        'Decounm', //Country
        'Decovst_ds', //Coverage status
        'Decover' //Coverage
      ]
    },

    {
      id: 229,
      key: 'BP_PROFILE_INCOMPLETE',
      fixedFilters: {
        Deprebp: ' '
      }
    },

    {
      id: 268,
      key: 'CREDITCARD_PAYPAL',
      fixedFilters: {
        Problem_desc: '1'
      },
      restricted: true,
      mapping: {
        Od_name: 'pss.id',
        Bp_name: 'bp.companyCountryId',
        Bp_group_id: 'bpGroup.id',
        Nam_id: 'nam.id'
      },
      columns: [
        {
          name: 'Bp_name',
          groupingSequence: 1
        },
        'Problem_desc',
        'Bp_country_name',
        'Accept_creditcard_desc',
        'Accept_paypal_desc',
        'Creditcard_connected_desc',
        'Paypal_connected_desc',
        'Webshop_name',
        'Webshop_country_name',
        'Webshop_creditcard_desc',
        'Webshop_paypal_desc',
        'Od_name',
        'Lam_name'
      ]
    },

    {
      id: 179,
      key: 'OPEN_SURVEY_QUESTIONS',
      fixedFilters: {
        Wvcomty: 'P',
        Dekeywo: 48,
        Deansok_ds: 0,
        Answered: 'null'
      },
      mapping: {
        Deccoid: 'bp.companyCountryId'
      },
      columns: [
        'Dequest', //Question
        'Deanswe', //Answer
        'Decommt', //Comment
        'Decredt', //Updated on
        'Deconnm', //Updated by
        'Decomnm', //Company
        'Decounm', //Country
        'Dewflty', //Type
        'Dekeywo', //Keyword
        'Odlname', //OD
        'Gvlname' //GBDM OEM
      ]
    },

    {
      id: 238,
      key: 'MISSING_OEM'
    },

    {
      id: 179,
      key: 'COUNTRY_INTEL',
      fixedFilters: {
        Dewtyds: 'COUNTRY',
        Dekeywo: 48
      },
      mapping: {
        Decounm: 'bp.country.id'
      },
      columns: [
        'Dequest', //Question
        'Deanswe', //Answer
        'Decommt', //Comment
        'Decredt', //Updated on
        'Deconnm', //Updated by
        'Decomnm', //Company
        'Decounm', //Country
        'Dewflty', //Type
        'Dekeywo', //Keyword
        'Odlname', //OD
        'Gvlname' //GBDM OEM
      ]
    },

    {
      id: 37,
      key: 'UPCOMING_ORDER_FEE',
      fixedFilters: {
        Declodt_FROM: null,
        Declodt_TO: null,
        Ready_for_invoicing: DateType.LAST_OF_PREVIOUS_MONTH,
        Deinvty: 'LOCAL',
        Deinvok: 'not',
        Deexclp: '!=',
        Devincl: 0,
        Decurce: 'TEM'
      },
      mapping: {
        Decodid: 'pss.id',
        Decomnm: 'bp.companyCountryId'
      },
      columns: [
        'Fhinvnr', // invoice id
        'Desprnm', //Customer
        'Decounm', //Country
        'Deconti', //Geography
        'Decomnm', //BP
        'Deordnr', //Order #
        'Depornr', //Customer PO#
        'Decredt', //Order date
        'Declodt', //Order closed date
        'Ac_lacharg', //ACSL+LAM fee
        'Delamcm', //LAM company
        'Delamcn', //LAM contact OEM,
        'Bpcustoinvnr' // BP to customer invoice number
      ]
    },

    {
      browselistCode: 'TICKET',
      key: 'BP_ACCOUNT_REVIEWS',
      fixedFilters: {
        Deiopen: 1,
        Demntty: '@REVIEW@',
        Dewtyds: 'TODO_BP'
      },
      mapping: {
        Deccoid: 'bp.companyCountryId'
      }
    },

    {
      browselistCode: 'TICKET',
      key: 'OPEN_COUNTRY_TRAINING',
      fixedFilters: {
        Deiopen: 1,
        Decnyds: '@KPI_OD_COUNTRY_TRAINING_LBDM@'
      },
      mapping: {
        Deccoid: 'bp.companyCountryId'
      }
    },

    {
      browselistCode: 'TICKET',
      key: 'BP_B2B',
      fixedFilters: {
        Deiopen: 1,
        Demntty: '@B2B@B2B Issues@'
      },
      mapping: {
        Deccoid: 'bp.companyCountryId'
      }
    },

    {
      browselistCode: 'USERS',
      key: 'NEW_BP_USERS',
      comments: 'New BP users since last week',
      fixedFilters: {
        Decredt_FROM: DateType.ONE_WEEK_AGO,
        Decmtds: 'P',
        Display_roles: 1
      },
      mapping: {
        Decomnm: 'bp.company.id',
        Decounm: 'bp.country.id',
        Decgrid: 'bpGroup.id',
        Deconid_search: 'nam.id'
      }
    },

    {
      browselistCode: 'USERS',
      key: 'BP_NAM_USERS',
      fixedFilters: {
        Usertype: 'P',
        Decmtds: 'P',
        Deordby: 'nvl(delogdt, sysdate - 10000) desc',
        Display_roles: 1
      },
      mapping: {
        Decomnm: 'bp.company.id',
        Decounm: 'bp.country.id',
        Decgrid: 'bpGroup.id',
        Deconid_search: 'nam.id'
      }
    },

    {
      browselistCode: 'USERS',
      key: 'BP_LAM_USERS',
      fixedFilters: {
        Usertype: 'PL',
        Decmtds: 'P',
        Deordby: 'nvl(delogdt, sysdate - 10000) desc',
        Display_roles: 1
      },
      mapping: {
        Decomnm: 'bp.company.id',
        Decounm: 'bp.country.id',
        Decgrid: 'bpGroup.id',
        Deconid_search: 'nam.id'
      }
    },

    {
      id: 245,
      key: 'BP_OFT_OEM',
      mapping: {
        Odlname: 'pss.id',
        Deccoid: 'bp.companyCountryId',
        Pacgrid: 'bpGroup.id'
      }
    },

    {
      id: 204,
      key: 'BP_DEFAULT_SLA',
      mapping: {
        Pss_name: 'pss.id',
        Bp_name: 'bp.companyCountryId',
        Bp_group: 'bpGroup.id',
        Bp_desk_name: 'bpDesk'
      }
    },

    {
      id: 260,
      key: 'BP_CAVEATS',
      mapping: {
        Odlname: 'pss.id',
        Deccoid: 'bp.companyCountryId',
        Pacgrid: 'bpGroup.id'
      }
    },

    {
      id: 261,
      key: 'BP_TC',
      mapping: {
        Odlname: 'pss.id',
        Deccoid: 'bp.companyCountryId',
        Pacgrid: 'bpGroup.id'
      },
      columns: [
        'Decounm',
        'Denname',
        'Dedescr',
        {
          name: 'Group_label',
          label: 'T&C group',
          groupingSequence: 1
        },
        'Group_label',
        'Agreewithdefault_ds',
        'Devalue_ds',
        'Deunity',
        'Dfvalue_ds',
        'Decommt',
        'Deopera_ds',
        'Odlname',
        'Cvlname',
        'Cvcredt',
        'Deconti',
        'Oddesk'

      ],
      fixedFilters: {
        Group_label: 'AGREEMENT,CAPABILITIES,TC'
      }
    },

    {
      id: 196,
      key: 'BP_MARGINS',
      mapping: {
        Decodnm: 'pss.id',
        Decomnm: 'bp.companyCountryId',
        Decgrid: 'bpGroup.id'
      },
      columns: [
        'Decomnm',
        'Bpcounm',
        {
          name: 'Deorigi_ds',
          label: 'Origin',
          groupingSequence: 1
        },
        'Dedescr',
        'Wvmarge',
        'Deminva',
        'Demincu',
        'Deweigh',
        'Dewflty',
        'Devendo',
        'Category_description',
        'Deserty_ds',
        'Decounm',
        'Deagree_ds',
        'Decommt',
        'Dembase_ds',
        'Demmeth_ds',
        'Demdest_ds',
        'Depayty_ds',
        'Depayco_ds',
        'Deinvty_ds',
        'Decondi',
        'Decodnm',
        'Wvmoddt',
        'Wvmodnm',
        'Delamto',
        'Delmcto',
        'Oddesk'

      ]
    },

    {
      id: 20,
      key: 'SERVICE_CATALOG',
      fixedFilters: {
        Decatyp_ds: 'SERVICES',
        Deopenp: 1
      },
      columns: [
        {
          name: 'Acsl_default_description',
          groupingSequence: 1
        },
        'Category_description',
        'Subcategory',
        'Deshods',
        'Deprice',
        'Decurce',
        'Default_price',
        'Price_difference',
        'Dedescr',
        'Bp_name'
      ],
      mapping: {
        Od_name: 'pss.id',
        Desprnm: 'bp.webshopId',
        Denname: 'bp.companyCountryId',
        Bp_group_id: 'bpGroup.id'
      }

    },

    {
      id: 231,
      key: 'COUNTRIES_OPEN_ITEMS',
      restricted: true
    }
  ]
};